var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collapse",
      class: { expanded: _vm.isExpand },
      attrs: { id: _vm.id },
    },
    [
      _c(
        "div",
        {
          staticClass: "title-container",
          class: [_vm.selfClass, _vm.titleContainerClass],
          on: { click: _vm.handleBarClick },
        },
        [
          _c(
            "div",
            { staticClass: "title-content" },
            [
              _vm.title
                ? _c(
                    "span",
                    {
                      staticClass: "default-title",
                      on: { click: _vm.titleFunc },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                  )
                : _vm._t("title"),
            ],
            2
          ),
          _vm._v(" "),
          _c("i", {
            class: [
              "arrow",
              _vm.isExpand ? _vm.expandIcons[0] : _vm.expandIcons[1],
              _vm.arrowClass,
            ],
            on: { click: _vm.handleArrowClick },
          }),
        ]
      ),
      _vm._v(" "),
      _vm._t("additional"),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: _vm.transitionName, tag: "div" } },
        [
          _vm.keepContentAlive
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isExpand,
                        expression: "isExpand",
                      },
                    ],
                    key: "content",
                    staticClass: "content",
                    class: { "with-border": _vm.withBorder },
                  },
                  [_vm._t("content")],
                  2
                ),
              ]
            : [
                _vm.isExpand
                  ? _c(
                      "div",
                      {
                        key: "content",
                        staticClass: "content",
                        class: { "with-border": _vm.withBorder },
                      },
                      [_vm._t("content")],
                      2
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }